import { FC, useState } from 'react';

import { DeviceType, FontAwesomeIcon, Preview } from '@appcharge/shared-ui';
import isEmpty from 'lodash/isEmpty';
import { Loader2 } from 'lucide-react';

interface IStoreThemeData {
  [key: string]: unknown;
}

interface IOfferPreviewSectionProps {
  previewProps: React.ComponentProps<typeof Preview>;
  storeThemeData: IStoreThemeData;
  enableDeviceToggle?: boolean;
}

export const OfferPreviewSection: FC<IOfferPreviewSectionProps> = ({
  previewProps,
  storeThemeData,
  enableDeviceToggle = false
}): React.ReactElement => {
  const [currentDevice, setCurrentDevice] = useState<DeviceType>(DeviceType.MOBILE);

  const toolbarButtonClasses = (active: boolean): string =>
    `text-[18px] w-8 h-8 cursor-pointer ${active ? 'text-indigo-300' : 'text-neutral-300'}`;

  const resolvedPreviewProps = enableDeviceToggle
    ? { ...previewProps, device: currentDevice }
    : previewProps;

  const previewWidth = enableDeviceToggle && currentDevice === DeviceType.DESKTOP
    ? 'w-full'
    : 'w-[450px] h-[682px]';

  return (
    <div className="w-1/2 h-full bg-zinc-100 px-16 pt-9 pb-8 overflow-y-auto">
      {enableDeviceToggle && (
        <div className="mb-9 flex items-center justify-between">
          <p className="text-[20px] font-semibold">Preview</p>
          <div className="flex items-center bg-white rounded-lg shadow border border-base-sidebarBorder p-1.5">
            <FontAwesomeIcon
              icon="fa-solid fa-mobile"
              className={toolbarButtonClasses(currentDevice === DeviceType.MOBILE)}
              onClick={() => setCurrentDevice(DeviceType.MOBILE)}
            />
            <hr className="bg-base-border w-[1px] h-6 mx-1" />
            <FontAwesomeIcon
              icon="fa-regular fa-desktop"
              className={toolbarButtonClasses(currentDevice === DeviceType.DESKTOP)}
              onClick={() => setCurrentDevice(DeviceType.DESKTOP)}
            />
          </div>
        </div>
      )}

      <div className="flex gap-12 justify-center items-center min-h-[667px]">
        {!isEmpty(storeThemeData) && !isEmpty(previewProps.offers) ? (
          <div className={previewWidth}>
            <Preview {...resolvedPreviewProps} hideHeader hideFooter />
          </div>
        ) : (
          <div className="flex items-center justify-center">
            <Loader2 className="h-16 w-16 animate-spin text-indigo-300" />
          </div>
        )}
      </div>
    </div>
  );
};
